import * as React from 'react'
import PropTypes from 'prop-types'

import './dialogosMarino.css'
import PronosMarinoDialog from './PronosMarionoDialog'
import ReferenciasMarino from './ReferenciasMarino'

function ReferenciasMarinoDialog({ open, handleClose, pathPrefixLogo }) {
    return (
        <PronosMarinoDialog
            open={open}
            handleClose={handleClose}
            pathPrefixLogo={pathPrefixLogo}
            dialogContent={<ReferenciasMarino />}
        />
    )
}

export default ReferenciasMarinoDialog

ReferenciasMarinoDialog.propTypes = {
    open: PropTypes.bool,
    handleClose: PropTypes.func,
    pathPrefixLogo: PropTypes.string,
}
